import {apiGet} from './index';
import {buildV2QueryParams} from './filters';

const VOLUME_IMPACT_KEYS = [
    'volumeLostCustomer',
    'volumeNewCustomer',
    'volumeDiscontinuedProduct',
    'volumeNewProduct',
    'volumeIncreasedProduct',
    'volumeDecreasedProduct',
];

const PRICE_IMPACT_KEYS = [
    'priceIncreasedProduct',
    'priceDecreasedProduct',
];

export const fetchProfitDriversAnalysis = (filters, callback) => {
    apiGet(`v2/profit-drivers/analysis${buildV2QueryParams(filters)}`, (resp) => {
        callback(resp?.success ? resp.data : null);
    });
};

export const buildProfitDriversPanelChartData = (data) => {
    const summary = data?.summary;
    if (!summary) {
        return [];
    }

    const sumImpactKeys = (keys) => keys.reduce(
        (total, key) => total + (summary[key]?.impact || 0),
        0
    );

    return [
        {name: 'Volume', value: sumImpactKeys(VOLUME_IMPACT_KEYS)},
        {name: 'Price', value: sumImpactKeys(PRICE_IMPACT_KEYS)},
        {name: 'Mix', value: summary.mix?.impact || 0},
    ];
};

export const getProfitDriversTotalImpact = (data) => data?.summary?.total?.impact || 0;
